import type { ElementType, PropsWithChildren } from 'react';
import React from 'react';
import * as styles from '../css/horizontal-content-padding.css';
import { classNames } from '../utils';

type Props<T extends ElementType> = {
    component?: T;
    className?: string;
} & React.ComponentPropsWithoutRef<T>;

const HorizontalContentPadding = <T extends ElementType = 'div'>({
    className,
    component,
    ...rest
}: PropsWithChildren<Props<T>>) => {
    const Component = component ?? 'div';

    return (
        <Component
            className={classNames(styles.root, className)}
            {...rest}
        />
    );
};

export default HorizontalContentPadding;
